/**
 * Default: Modules > Clinic Management > Filter
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import EventHandler from '../../../shared/dom/event-handler';
import Manipulator from '../../../shared/dom/manipulator';

// -------
// Private
// -------

const NAME = 'clinic-management';

const filterInstitutionTypes = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-tabgroup .tab`);
	const HIDDEN_FIELD = SelectorEngine.findOne(`.${NAME}-tabgroup .institution-type`);

	let form;

	if(!COLLECTION.length || !HIDDEN_FIELD) {
		return;
	}

	form = HIDDEN_FIELD.form;

	for(const element of COLLECTION) {
		EventHandler.on(element, 'click', (event) => {
			event.preventDefault();

			HIDDEN_FIELD.setAttribute('value', Manipulator.getDataAttribute(element, 'uid'));
			EventHandler.trigger(HIDDEN_FIELD, 'change');
		});
	}

	EventHandler.on(HIDDEN_FIELD, 'change', () => {
		if(form) {
			form.submit();
		}
	});
};

const filterInstitutionCategories = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-select .form-select`);

	if(!COLLECTION.length) {
		return;
	}

	for(const element of COLLECTION) {
		EventHandler.on(element, 'change', (event) => {
			event.preventDefault();

			let form = event.delegateTarget.form;

			if(form) {
				form.submit();
			}
		});
	}
};

// -------
// Public
// -------

/**
 * init ClinicManagement Filter
 */
const init = () => {
	filterInstitutionTypes();
	filterInstitutionCategories();
};

// Execute
init();
